module.exports = __webpack_public_path__ + "static/media/loading-load.556e9ff8.gif";